import { render, staticRenderFns } from "./LineQuesting.vue?vue&type=template&id=22b8b770&scoped=true"
import script from "./LineQuesting.vue?vue&type=script&lang=js"
export * from "./LineQuesting.vue?vue&type=script&lang=js"
import style0 from "./LineQuesting.vue?vue&type=style&index=0&id=22b8b770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8b770",
  null
  
)

export default component.exports